// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"453":"fa99c400","751":"2f955bb0","780":"240c39fe","822":"4d09edfd","827":"c82f92dd","831":"44bb846c","906":"2ff76afa","972":"d905d5f1"}[chunkId] + ".chunk.js";
};